import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, vShow as _vShow, mergeProps as _mergeProps, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import { shareInfo } from '@dc-platform/dc-interaction'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  workCode: {
    type: String
  },
  controlType: {
    type: String,
    default: 'disabled' // disabled=>按钮disabled属性 none 直接隐藏
  }
},
  setup(__props) {

const props = __props
const userInfo = ref<any>({})
onMounted(() => {
  userInfo.value = shareInfo.getUserInfo() || {}
})
const showComputed = computed(() => {
  if (props.controlType === 'none') {
    if (props.workCode && userInfo.value.work_code) {
      return props.workCode === userInfo.value.work_code
    }
  }
  return true
})
const disabledComputed = computed(() => {
  if (props.disabled) {
    return true
  }
  // 判断是否是客户负责人
  if (props.workCode && userInfo.value.work_code) {
    return props.workCode !== userInfo.value.work_code
  }
  return false
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return _withDirectives((_openBlock(), _createBlock(_component_a_button, _mergeProps(_ctx.$attrs, { disabled: disabledComputed.value }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["disabled"])), [
    [_vShow, showComputed.value]
  ])
}
}

})